
document.addEventListener('DOMContentLoaded', () => {
  const initMegaMenu = () => {
    const megaMenus = document.querySelectorAll('.mega-menu-container');

    megaMenus.forEach(menu => {
      const productLinks = menu.querySelectorAll('.product-nav-link');
      const productPanels = menu.querySelectorAll('.product-info-panel');

      if (productLinks.length === 0) return;

      const activateTab = (link) => {
        productLinks.forEach(l => {
          l.classList.remove('active');
          l.setAttribute('aria-selected', 'false');
          l.setAttribute('tabindex', '-1');
        });
        productPanels.forEach(p => {
          p.classList.remove('active');
          p.setAttribute('aria-hidden', 'true');
        });
        link.classList.add('active');
        link.setAttribute('aria-selected', 'true');
        link.setAttribute('tabindex', '0');
        const targetId = link.getAttribute('data-target');
        const targetPanel = menu.querySelector(`.product-info-panel[data-id="${targetId}"]`);
        if (targetPanel) {
          targetPanel.classList.add('active');
          targetPanel.setAttribute('aria-hidden', 'false');
        }
      };

      productLinks.forEach(link => {
        link.addEventListener('mouseenter', () => activateTab(link));
        link.addEventListener('click', (e) => {
          e.preventDefault();
          activateTab(link);
        });
        link.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
            e.preventDefault();
            const idx = Array.from(productLinks).indexOf(link);
            const next = productLinks[Math.min(productLinks.length - 1, idx + 1)];
            if (next) activateTab(next);
          } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const idx = Array.from(productLinks).indexOf(link);
            const prev = productLinks[Math.max(0, idx - 1)];
            if (prev) activateTab(prev);
          }
        });
      });
    });
  };

  const initHoverIntent = () => {
    const headerItems = document.querySelectorAll('.header__menu-item');
    headerItems.forEach(item => {
      const menu = item.nextElementSibling;
      if (!menu || !menu.classList.contains('mega-menu-container')) return;
      let closeTimer = null;
      const open = () => {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        menu.classList.add('open');
      };
      const scheduleClose = () => {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          menu.classList.remove('open');
        }, 200);
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', scheduleClose);
      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', scheduleClose);
    });
  };

  initMegaMenu();
  initHoverIntent();

  // Re-init on section re-render (for Theme Editor)
  document.addEventListener('shopify:section:load', () => {
    initMegaMenu();
    initHoverIntent();
  });
});
